import React from 'react';

interface EcoTipsProps {
  open: boolean;
  onClose: () => void;
}

const infoRows = [
  {
    label: 'Ideal per person (global goal)',
    value: '167',
    notes: 'Based on 2 tonnes/year climate target',
  },
  {
    label: 'Current global avg',
    value: '~333',
    notes: 'Varies by region and lifestyle',
  },
  {
    label: 'Myǃhū target zone',
    value: '<250',
    notes: 'Tier for eco-conscious users',
  },
  {
    label: 'Household target (2–4 people)',
    value: '417–600',
    notes: 'Recommended range for family tracking',
  },
];

const EcoTips: React.FC<EcoTipsProps> = ({ open, onClose }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="text-left bg-white dark:bg-[#18181b] rounded-xl shadow-xl max-w-[50%] w-full p-6 relative">
        <button
          className="absolute top-3 right-3 text-gray-400 hover:text-[#40e0d0] text-2xl font-bold"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
        <h3 className="text-2xl font-bold mb-4 text-[#40e0d0]">Myǃhū Carbon Goal Info</h3>
        <p className="text-muted-foreground mb-6 text-sm">
          Understanding your carbon goal helps you track your impact and set realistic, climate-friendly targets. Here are some reference values:
        </p>
        <div className="overflow-x-auto">
          <table className="min-w-full border rounded text-sm mb-4">
            <thead>
              <tr className="bg-[#40e0d0]/10">
                <th className="px-3 py-2 text-left font-semibold">Label</th>
                <th className="px-3 py-2 text-left font-semibold">Value (kg CO₂e)</th>
                <th className="px-3 py-2 text-left font-semibold">Notes</th>
              </tr>
            </thead>
            <tbody>
              {infoRows.map((row, i) => (
                <tr key={i} className="border-t">
                  <td className="px-3 py-2 whitespace-nowrap">{row.label}</td>
                  <td className="px-3 py-2 font-bold text-[#40e0d0]">{row.value}</td>
                  <td className="px-3 py-2 text-xs text-gray-500">{row.notes}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="text-xs text-gray-400">
          <span>Tip: The lower your carbon footprint, the closer you are to climate goals. Track progress and aim for the Myǃhū target zone!</span>
        </div>
      </div>
    </div>
  );
};

export default EcoTips;


